// extracted by mini-css-extract-plugin
export var mt0 = "phone-module--mt-0--c7161";
export var mt1 = "phone-module--mt-1--fe04d";
export var mt2 = "phone-module--mt-2--d24b4";
export var mt3 = "phone-module--mt-3--2648f";
export var mt4 = "phone-module--mt-4--02255";
export var mt5 = "phone-module--mt-5--c0045";
export var mt6 = "phone-module--mt-6--98c2b";
export var phone = "phone-module--phone--7055c";
export var phoneDark = "phone-module--phone--dark--4c265";
export var phoneTransparent = "phone-module--phone--transparent--82edd";
export var phone__el = "phone-module--phone__el--c3285";